import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { auth, db, functions } from './firebaseConfig';
import { Container } from '@mui/material';
import OrganizationDropdown from './OrganizationDropdown';
import AdminCreateUser from './AdminCreateUser';
import AdminUserTable from './AdminUserTable';
import AdminBatchCreateUsers from './AdminBatchCreateUsers';
import { checkAdminStatus } from './utils/authUtils';
import { httpsCallable } from 'firebase/functions';

const AdminPage = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [organization, setOrganization] = useState('');

  useEffect(() => {
    const fetchAdminData = async () => {
      const currentOrg = auth.currentUser.email.split('@')[1].split('.')[0];
      const { isAdmin, isSuperAdmin } = await checkAdminStatus(currentOrg);

      setIsAdmin(isAdmin);
      setIsSuperAdmin(isSuperAdmin);
      setOrganization(currentOrg);

      if (isAdmin || isSuperAdmin) {
        fetchUsersForOrg(currentOrg);
      }
    };

    fetchAdminData();
  }, []);

  useEffect(() => {
    if (organization) {
      fetchUsersForOrg(organization);
    }
  }, [organization]); // Refetch users when the organization changes

  const deleteUser = httpsCallable(functions, 'deleteUser');

  const handleDeleteUser = async (userId) => {
    try {
      const result = await deleteUser({ userId, organization });
      console.log(result.data.message);
      fetchUsersForOrg(organization);
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  const fetchUsersForOrg = async (org) => {
    try {
      const querySnapshot = await getDocs(collection(db, `users-${org}`));
      const userList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setUsers(userList);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (!isAdmin) {
    return <div>You do not have admin privileges.</div>;
  }

  return (
    <Container>
      {isSuperAdmin && <OrganizationDropdown organization={organization} setOrganization={setOrganization} />}

      <AdminBatchCreateUsers fetchUsers={() => fetchUsersForOrg(organization)} />
      <AdminCreateUser fetchUsers={() => fetchUsersForOrg(organization)} organization={organization}/>
      <AdminUserTable
        users={users}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleDeleteUser={handleDeleteUser}
      />
    </Container>
  );
};

export default AdminPage;
